import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { SnackbarService } from '~/core/services/snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  protected dialog = inject(MatDialog);
  protected snackbarService = inject(SnackbarService);
  protected translateService = inject(TranslateService);

  isOpened = false;
  errors = [3351];

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        const errorCode = error?.error?.code;

        if (this.errors.includes(errorCode)) {
          const errorMessage = this.translateService.instant(`SERVER_ERROR.${errorCode}`);
          this.snackbarService.showError(errorMessage);
        }

        return throwError(() => error);
      }),
    );
  }
}
